import { FC } from 'react';
import { AllIncome as AllIncomeTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/AllIncome';
import { EmployeeIncomeForm } from './Form';
import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { LoadingPage } from '../../Loading';
import { INCOME } from './query';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import styles from './AllIncome.scss';

type AllIncomeProps = {
  question: Question;
};

export const AllIncome: FC<AllIncomeProps> = ({ question }) => {
  const { loading, data } = useEmployeeQuery(INCOME);
  const profile = data?.request?.profile;
  if (loading) return <LoadingPage />;
  return (
    <AllIncomeTemplate question={question} initiallyOpen={true}>
      <div className={styles.redDescription}>
        「当社」欄は今年1年間の見込み収入金額（賞与含む、前職除く）を入力してください。
        <br />
        「他社」欄は2か所以上からの給与収入がある場合にその金額を入力してください。
      </div>
      <EmployeeIncomeForm profile={profile} />
    </AllIncomeTemplate>
  );
};
